var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code"},[_c('h4',{staticClass:"text-center p-2"},[_vm._v(_vm._s(_vm.$t('company-code.company-code-title')))]),_c('div',{staticClass:"rc-datetime"}),_c('div',{staticClass:"code-info"},[_c('div',{staticClass:"group-btn"},[_c('router-link',{attrs:{"tag":"button","to":{ name: 'company-qrscan' }}},[_c('v-btn',{attrs:{"id":"btn-scan","color":"#e8320d","height":"70"},domProps:{"innerHTML":_vm._s(
            _vm.$t('company-code.btn-use-qr', {
              split: '<br />'
            })
          )}})],1),_c('div',{staticClass:"margin",staticStyle:{"padding-top":"50px"}},[_c('router-link',{attrs:{"tag":"button","to":{ name: 'company-codescan' }}},[_c('v-btn',{attrs:{"id":"btn-code","color":"#e8320d","height":"70"},domProps:{"innerHTML":_vm._s(
              _vm.$t('company-code.btn-use-code-manual', {
                split: '<br />'
              })
            )}})],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }